import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
} from "@fortawesome/free-solid-svg-icons";
import fetchConversationData from "../Utils/UserMessageLoadChatHistory"
import "../../../Styles/common-styles.css"
import "../../Styles/uac-common-styles.css"
import kleidoLogo from "../../../../../assets/images/kleido-logoonly.png"

const UMGridLeftLayout = ({ recipientId }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [profileImage] = useState("/assets/Profile/profile-biker.jpeg"); 
  const [conversations, setConversations] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchConversationData();
      if (typeof data !== "object") {
        throw new Error("Invalid JSON structure");
      }
      setConversations(data);
    };

    fetchData();
  }, []);

  return (
    <div style={{display: "flex", flexDirection: "column"}}>
      <div className="uac-profile-section" style={{display: "flex", flexDirection: "row", marginTop: 30}}>
        <img src={kleidoLogo} alt="Kleido" className="h-12 w-12 rounded-lg" />
        <h2 className="subgroup-header" style={{fontSize: 30, color: "white"}}> Chat History </h2>
      </div>

        {/* Search Bar */}
        <div className="uac-search-bar">
          <input
            type="text"
            placeholder="Search chat history..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="uac-conversations-history" >
        {conversations?.conversations?.map((conversation) => (
          <div key={conversation.month} className="month-section">
            <h4 className="month-title">{conversation.month}</h4>

            {conversation.allmessages?.map((entry) => (
              <div key={entry.date} className="date-section">
                <div className="date-label">{entry.date}</div>
                  <ul className="message-list">
                    {entry.messages?.map((msg) => (
                      <li key={msg.id} className="message-item">
                        <strong>{msg.sender}</strong>: {msg.content}
                      </li>
                    ))}
                  </ul>
                </div>
                ))}
              </div>
            ))}
      </div>
    </div>
  );
};

export default UMGridLeftLayout;
